module.exports = __webpack_public_path__ + "10bcf5e76d6248f89515d49cf9b9e9c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/2/Assets/mealplanner.png
// module id = 1325
// module chunks = 0